<template>
  <div :class="['flex flex-col w-full h-full', isAbove ? 'flex-col' : ' flex-col-reverse']">
    <div class="w-full flex mb-2">
      <section class="relative" @mouseleave="showToSegment = false">
        <button
          class="btn btn-outline flex"
          @click="showToSegment = !showToSegment"
        >
          To segment {{ toSegmentName && `: ${toSegmentName}` }}
          <font-awesome-icon
            class="reaction text-gray-800 ml-4"
            size="lg"
            :icon="['fas', 'caret-down']"
          />
        </button>
        <div :class="['absolute z-40', showToSegment ? 'flex' : 'hidden']">
          <div class="mr-3 bg-white shadow-lg rounded-md">
            <h4 class="text-center mt-3 mb-1 text-lg font-semibold">Add to</h4>
            <hr />
            <ul class="max-h-64 overflow-hidden overflow-y-scroll">
              <li
                :class="[
                  'hover:bg-blue-600 hover:text-white cursor-default whitespace-no-wrap px-4',
                  addToSegment === ''
                    ? ' text-white bg-blue-700'
                    : 'text-black',
                ]"
                @click="
                  () => {
                    addToSegment = '';
                    if (moveToSegment === '') return (toSegmentName = '');
                  }
                "
              >
                Select segment
              </li>
              <li
                v-for="(data, index) in segmentsList"
                :key="index + data._id"
                :class="[
                  'hover:bg-blue-600 hover:text-white cursor-default whitespace-no-wrap px-4',
                  addToSegment === data._id
                    ? ' text-white bg-blue-700'
                    : 'text-black',
                ]"
                @click="
                  () =>
                    handleSelectSegment(data._id, 'addToSegment', data.title)
                "
              >
                {{
                  data.title.length > 15
                    ? `${data.title.slice(0, 15)}...`
                    : data.title
                }}
              </li>
            </ul>
          </div>
          <div class="bg-white shadow-lg rounded-md">
            <h4 class="text-center mt-3 mb-1 text-lg font-semibold">Move to</h4>
            <hr />
            <ul class="max-h-64 overflow-hidden overflow-y-scroll">
              <li
                :class="[
                  'hover:bg-blue-600 hover:text-white cursor-default whitespace-no-wrap px-4',
                  moveToSegment === ''
                    ? ' text-white bg-blue-700'
                    : 'text-black',
                ]"
                @click="
                  () => {
                    moveToSegment = '';
                    if (addToSegment === '') return (toSegmentName = '');
                  }
                "
              >
                Select segment
              </li>
              <li
                v-for="(data, index) in segmentsList"
                :key="index + data._id"
                :class="[
                  ' hover:bg-blue-600 hover:text-white cursor-default whitespace-no-wrap px-4',
                  moveToSegment === data._id
                    ? ' text-white bg-blue-700'
                    : 'text-black',
                ]"
                @click="
                  () =>
                    handleSelectSegment(data._id, 'moveToSegment', data.title)
                "
              >
                {{
                  data.title.length > 15
                    ? `${data.title.slice(0, 15)}...`
                    : data.title
                }}
              </li>
            </ul>
          </div>
        </div>
      </section>
      <section class="ml-auto flex justify-center items-center">
        <div v-if="!providerId ">
          <h4 :class="['mb-0 mr-5', message.length > tweetTextlenght ? ' text-red-600 font-semibold' : ' text-gray-700']">{{message.length}}/{{tweetTextlenght}}</h4>
        </div>
        <button
          :disabled="!message.trim() || (message.length > tweetTextlenght && !providerId)"
          @click="handleReply"
          type="button"
          class="btn btn-outline"
        >
         {{ !this.providerId ? 'Reply' : 'Send'}}
        </button>
      </section>
    </div>
 <hr class="my-3" />
    <textarea
      placeholder="Reply here..."
      name="replyText"
      id=""
      cols="30"
      rows="10"
      class="w-full flex-1 border border-gray-500 rounded-md p-3"
      v-model="message"
    ></textarea>

  </div>
</template>

<script>
import store from '@/store';
import courseApi from '@/services/course';
import utils from '@/services/utils';
import admin from '@/services/admin';

export default {
  name: 'TweetReply',
  layout: 'admin',
  store,
  props: [
    'tweetInfo',
    'loadingCallback',
    'autoLike',
    'providerId',
    'acctUsername',
  ],
  data() {
    return {
      activityData: {},
      message: '',
      showToSegment: false,
      addToSegment: '',
      moveToSegment: '',
      toSegmentName: '',
      isAbove: false,
      tweetTextlenght: 265,
    };
  },
  computed: {
    segmentsList() {
      return this.$store.state.courses.segmentOnly || [];
    },
    currentSegemnt: {
      get() {
        return this.$store.state.connect.currentSegment;
      },
      set(newValue) {
        return newValue;
      },
    },
    userDetails() {
      return this.$store.state?.userDetails;
    },
  },
  watch: {
    tweetInfo() {
      this.activityData = this.tweetInfo;
      this.tweetTextlenght = this.tweetInfo ? (280 - (this.tweetInfo?.user?.username?.length + 2)) : 280;
    },
    userDetails(newVal) {
      this.isAbove = newVal?.configureInfo?.connectTabBtnShowAbove;
    },
  },
  mounted() {
    this.isAbove = this.userDetails?.configureInfo?.connectTabBtnShowAbove;
    this.tweetTextlenght = this.tweetInfo ? (280 - (this.tweetInfo?.user?.username?.length + 2)) : 280;
  },
  methods: {
    async handleReply() {
      try {
        this.loadingCallback(true);
        if (!this.providerId) {
          const data = {
            studentId: this.tweetInfo.user.id,
            tweetId: this.tweetInfo.id,
            message: this.message.trim(),
            autoLike: this.autoLike,
          };
          const replyRes = await courseApi.replyTweet(data);
          console.log(replyRes);
          utils.setStatusMsg(this, replyRes.message);
          this.loadingCallback(false);
          this.message = '';
        } else {
          const data = {
            recieverIds: [this.providerId],
            message: [this.message.trim()],
            isPoll: false,
            payload: {
              firstOption: {},
              secondOption: {},
              thirdOption: {},
            },
          };
          const response = await admin.sendDMCrone(data);
          console.log(response);
          utils.setStatusMsg(this, response.message);
          this.message = '';
          this.loadingCallback(false);
        }
        if (this.addToSegment !== '' || this.moveToSegment !== '') {
          await this.$store.dispatch('inviteMemberToCourse', {
            username: this.acctUsername
              ? this.acctUsername
              : this.tweetInfo?.user?.username,
            courseId: this.addToSegment || this.moveToSegment,
            Type: 'username',
          });
        }
        console.log(this.providerId, this.acctUsername, 'this.acctUsername');
        if (this.moveToSegment !== '') {
          await this.$store.dispatch('removeMemberByProviderId', {
            studentProviderId: this.providerId
              ? this.providerId
              : this.tweetInfo?.user?.id_str,
            courseId: this.currentSegemnt,
          });
        }
      } catch (err) {
        console.log(' reply error', err);
        utils.setStatusMsg(
          this,
          err?.allErrors ? err?.allErrors[0].message : err?.response?.data?.message || err?.message,
        );
        this.loadingCallback(false);
      } finally {
        await this.$store.dispatch('getCronNotification');
      }
    },
    handleSelectSegment(segmentId, type, title) {
      if (type === 'addToSegment') {
        this.addToSegment = segmentId;
        this.moveToSegment = '';
        this.toSegmentName = title;
      } else {
        this.addToSegment = '';
        this.moveToSegment = segmentId;
        this.toSegmentName = title;
      }
      this.showToSegment = false;
    },
  },
};
</script>
